import { FaReply, FaExternalLinkAlt, FaPhoneAlt, FaCopy, FaCheckDouble, FaRegImage, FaRegFilePdf, FaPlay } from 'react-icons/fa';

// Preview estilo WhatsApp de um template (puro visual). Reproduz o TemplateBubble
// do UniTicket: cabeçalho (texto/mídia), corpo com {{n}} resolvidas, rodapé e botões.

const BUBBLE_BG = '#d9fdd3';
const CHAT_BG = '#efeae2';
const VAR_BG = '#ffe8a3';

const BTN_ICON = {
  QUICK_REPLY: FaReply,
  URL: FaExternalLinkAlt,
  PHONE_NUMBER: FaPhoneAlt,
  COPY_CODE: FaCopy,
};

function renderBody(text, getExample) {
  const parts = String(text || '').split(/({{\s*\d+\s*}})/g);
  return parts.map((part, i) => {
    const match = part.match(/{{\s*(\d+)\s*}}/);
    if (!match) return <span key={i}>{part}</span>;
    const example = getExample?.(Number(match[1]));
    return example ? (
      <strong key={i}>{example}</strong>
    ) : (
      <span key={i} style={{ background: VAR_BG, borderRadius: 4, padding: '0 4px' }}>{part}</span>
    );
  });
}

function MediaHeader({ type }) {
  const base = {
    height: 140,
    borderRadius: 8,
    marginBottom: 6,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#c9e3c2',
    color: '#4a6b45',
  };
  if (type === 'IMAGE') return <div style={base}><FaRegImage size={40} /></div>;
  if (type === 'VIDEO') return <div style={base}><FaPlay size={34} /></div>;
  if (type === 'DOCUMENT') return <div style={{ ...base, height: 64, justifyContent: 'flex-start', paddingLeft: 12, gap: 10 }}><FaRegFilePdf size={26} /> <span style={{ fontSize: 12 }}>documento.pdf</span></div>;
  return null;
}

export default function TemplateBubble({ headerType, headerContent, bodyText, footerText, buttons = [], getExample }) {
  return (
    <div style={{ background: CHAT_BG, padding: 14, borderRadius: 12 }}>
      <div
        style={{
          maxWidth: 320,
          marginLeft: 'auto',
          background: BUBBLE_BG,
          borderRadius: 10,
          borderTopRightRadius: 2,
          padding: 8,
          boxShadow: '0 1px 1px rgba(0,0,0,0.15)',
          fontSize: 14,
          color: '#111b21',
        }}
      >
        {headerType === 'TEXT' && headerContent && (
          <div style={{ fontWeight: 700, marginBottom: 4 }}>{headerContent}</div>
        )}
        {['IMAGE', 'VIDEO', 'DOCUMENT'].includes(headerType) && <MediaHeader type={headerType} />}

        <div style={{ whiteSpace: 'pre-wrap', lineHeight: 1.4 }}>
          {renderBody(bodyText || 'Escreva o conteúdo da mensagem…', getExample)}
        </div>

        {footerText && (
          <div style={{ fontSize: 12, color: '#667781', marginTop: 6 }}>{footerText}</div>
        )}

        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 4, marginTop: 4 }}>
          <span style={{ fontSize: 11, color: '#667781' }}>9:41</span>
          <FaCheckDouble size={12} color="#53bdeb" />
        </div>
      </div>

      {buttons.length > 0 && (
        <div style={{ maxWidth: 320, marginLeft: 'auto', marginTop: 4 }}>
          {buttons.map((b, i) => {
            const Icon = BTN_ICON[b.type] || FaReply;
            return (
              <div
                key={i}
                style={{
                  background: '#fff',
                  color: '#00a5f4',
                  textAlign: 'center',
                  padding: '9px',
                  borderRadius: 8,
                  marginTop: 4,
                  fontSize: 14,
                  fontWeight: 500,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 8,
                  boxShadow: '0 1px 1px rgba(0,0,0,0.1)',
                }}
              >
                <Icon size={13} /> {b.text || 'Botão'}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
